import { render } from "./NewPlayerForm.vue?vue&type=template&id=1f8c1d0b&scoped=true"
import script from "./NewPlayerForm.vue?vue&type=script&lang=js"
export * from "./NewPlayerForm.vue?vue&type=script&lang=js"

import "./NewPlayerForm.vue?vue&type=style&index=0&id=1f8c1d0b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8c1d0b"]])

export default __exports__